import { getHomeVideoRequest } from "../repositories/home_video_repository";

export const HomeVideoService = () => {
    const fetchHomeVideo = async (setHomeVideo) => {
        try {
            const response = await getHomeVideoRequest();
            if (response?.success && response.data?.link) {
                setHomeVideo(response.data);
            } else {
                setHomeVideo(null);
            }
        } catch (error) {
            console.error("Failed to fetch home video.");
            setHomeVideo(null);
        }
    };
    return {
        fetchHomeVideo,
    };
};
